export const name = state => state.name

export const path = state => state.path
